export default "__VITE_PUBLIC_ASSET__6216ca61__"